<template>
  <!-- Spans one menu column per 10 links, or the given `columns` (see groupColumns; `--mega-menu-column` is set by
       MegaMenuPanel). -->
  <div class="flex flex-col gap-4 min-w-0" :style="{ gridColumn: `span ${columns}` }">
    <h3 class="text-sm font-medium text-muted-foreground py-1">{{ $t(label) }}</h3>
    <!-- Fills top to bottom, starting a new column only after 10 links. The column gap matches the panel's,
         so the extra columns line up with the menu columns. -->
    <ul
      class="grid grid-flow-col gap-x-8 gap-y-5"
      :style="{
        gridTemplateRows: `repeat(${rows}, auto)`,
        gridTemplateColumns: `repeat(${columns}, var(--mega-menu-column))`,
      }">
      <li v-for="link in links" :key="link.label" class="min-w-0">
        <RouterLink
          :to="link.to"
          class="flex items-center text-sm font-semibold hover:underline"
          :title="$t(link.label)"
          @click="emit('navigate')">
          <span class="truncate">{{ $t(link.label) }}</span>
        </RouterLink>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { RouteLocationRaw } from "vue-router";
import { groupColumns } from "./useMegaMenu";

const props = defineProps<{
  label: string;
  links: { label: string; to: RouteLocationRaw }[];
  // Spread the links evenly over this many columns (left column first) instead of filling 10 per column.
  columns?: number;
}>();
const emit = defineEmits<{ navigate: [] }>();

const columns = computed(() => groupColumns(props));
const rows = computed(() => Math.ceil(props.links.length / columns.value));
</script>
